import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTag = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3335 5.33337C4.3335 4.78109 4.78121 4.33337 5.3335 4.33337H12.0002C12.2654 4.33337 12.5197 4.43873 12.7073 4.62627L18.436 10.355C19.3407 11.2651 19.3407 12.735 18.436 13.645L18.4339 13.6471L13.6543 18.4268C13.2167 18.8649 12.6228 19.1111 12.0035 19.1111C11.3843 19.1111 10.7905 18.865 10.3529 18.427C10.3528 18.4269 10.3529 18.427 10.3529 18.427L4.6268 12.7076C4.43901 12.52 4.3335 12.2655 4.3335 12V5.33337ZM6.3335 6.33337V11.5855L11.7677 17.0133C11.8302 17.0759 11.915 17.1111 12.0035 17.1111C12.092 17.1111 12.1768 17.0759 12.2393 17.0133L17.0176 12.235C17.0174 12.2353 17.0178 12.2348 17.0176 12.235C17.146 12.1052 17.1466 11.8955 17.0183 11.7657C17.0181 11.7655 17.0185 11.7659 17.0183 11.7657L11.5859 6.33337H6.3335Z"
        />
      </svg>
    );
  }
);
